import { tooltipData, tooltipHelp } from "../createTooltip.js";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

const DrawPolygonMode = MapboxDraw.modes.draw_polygon;

const _onMouseMove = DrawPolygonMode.onMouseMove;

DrawPolygonMode.onMouseMove = function (state, e) {
  const result = _onMouseMove.apply(this, [state, e]);

  const feature = state.polygon.toGeoJSON();

  tooltipData([feature], "polygon");
  tooltipHelp([feature], "polygon");
  state.polygon.properties.sysType = "polygon";
  state.polygon.properties.sysData = tooltipData(
    [feature],
    "polygon",
    false,
    true
  );
  // this.map.fire("draw.customOnMouseMove", {
  //   features: [feature],
  //   asd: "polygon"
  // });

  return result;
};

export default DrawPolygonMode;
